import { matchPath } from 'Commons/helpers/utils/RouteHelpers';

const doesUrlBelongsToAnyGivenPath = (url = '', paths = [], prefix = '') => paths.some(
    path => matchPath(url, { path: `${prefix}/${path}` }),
);

export default doesUrlBelongsToAnyGivenPath;
